import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import {
  Box,
  Typography,
  Button,
  Paper,
  Grid,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  Input,
  TextField,
  CircularProgress,
  DialogContent,
  DialogTitle,
  Dialog,
} from "@mui/material";
import useErrorHandler from "../../hooks/useErrorHandler";
import { useNavigate, useParams } from "react-router-dom";
import {
  getAllColumns,
  getReportsByReportName,
  getReportsExportExcelData,
  getSubsidiaryOption,
} from "../../api/reports.js";
import { ReportsViewTable } from "../../config/grid-column-defs.js";
import { saveAs } from "file-saver";
import { getTransactionDownloadfile } from "../../api/invoice.js";

export default function SavedSearchViewList() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const errorHandler = useErrorHandler();
  const snackbar = useSnackbar();
  const params = useParams();
  const { data: user } = useSelector((state) => state.user);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [columnNames, setAllColumnNames] = useState([]);
  const [reportViewTableColumns, setReportViewTableColumns] = useState([]);
  const [onInputSearch, setInputSearch] = useState({});
  const [periodSearchInputValue, setPeriodSearchValue] = useState("");
  const [dateSearchInputValue, setDateSearchValue] = useState("");
  const [yearSearchInputValue, setYearSearchValue] = useState("");
  const [monthSearchInputValue, setMonthSearchValue] = useState("");
  const [subsidiarySearchInputValue, setSubsidiarySearchValue] = useState("");
  const [subsidiaryOptions, setSubsidiaryOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [percentComplete, setPercentComplete] = useState(0);
  const handleReset = (e) => {
    setInputSearch({});
    setPeriodSearchValue("");
    setMonthSearchValue("");
    setYearSearchValue("");
    setSubsidiarySearchValue("");
    setDateSearchValue("");
  };

  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  useEffect(() => {
    if (user?.token) {
      getSubsidiaryOptionsList();
    }
  }, [user?.token]);

  async function getReportsListByReportNameData(limit, offset) {
    try {
      const { data } = await getReportsByReportName(
        user?.token,
        onInputSearch
          ? {
              limit,
              offset,
              ...onInputSearch,
              type:"savedsearch",
              report_name: params.tableName,
            }
          : {
              limit,
              offset,
              type:"savedsearch",
              report_name: params.tableName,
            }
      );
      // if (!data.Reportdata.data || data.Reportdata.data.length === 0) {

      //   return ;
      // }
      // const columns = await getAllColumnList();
      const dynamicColumns = generateDynamicColumns(
        // columns,  do alphabetical pass this columns in place of data.Reportdata.ReportColumns
        data.Reportdata.ReportColumns,
        data.Reportdata.data
      );
      setReportViewTableColumns(dynamicColumns);
setSubsidiaryOptions(data?.Reportdata?.listsubsidiery)
      return {
        rows: data.Reportdata.data,
        total: data.Reportdata.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    }
  }

  const onPeriodInputSearch = (event) => {
    setPeriodSearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, period: event.target.value });
  };
  const onDateInputSearch = (event) => {
    setDateSearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, date: event.target.value });
  };
  const onYearInputSearch = (event) => {
    setYearSearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, year: event.target.value });
  };
  const onSubsidiaryInputSearch = (event) => {
    setSubsidiarySearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, subsidiary: event.target.value });
  };
  const onMonthInputSearch = (event) => {
    setMonthSearchValue(event.target.value);
    setInputSearch({ ...onInputSearch, month: event.target.value });
  };
  useEffect(() => {
    refreshTable();
  }, [onInputSearch]);

  useEffect(() => {
    setInputSearch({});
    handleReset();
  }, [params.tableName]);

  async function getSubsidiaryOptionsList() {
    try {
      const { data } = await getSubsidiaryOption(user.token, {

      });
      // setSubsidiaryOptions(data.data);
    } catch (error) {
      snackbar.showError(error);
      errorHandler(error);
    }
  }
  
  // async function getAllColumnList() {
  //   try {
  //     const { data } = await getAllColumns(user.token, {
  //       col_name: "",
  //       limit: "",
  //       offset: "",
  //     });
  //     setAllColumnNames(data.data.ColumnsList);
  //     return data.data.ColumnsList;
  //   } catch (error) {
  //     errorHandler(error);
  //   }
  // }

  // Function to dynamically generate columns based on the API response
  function generateDynamicColumns(allColumns, reportColumns) {
    const staticColumns = ReportsViewTable; // Assuming ReportsViewTable is your static column configuration
    const dynamicColumns = allColumns
      .filter((c) =>
        reportColumns.some((obj) => Object.keys(obj).includes(c.column_name))
      )
      .map((column) => {
        const headerText = column.column_name.toUpperCase();
        const textWidth = getTextWidth(headerText, "bold 14px Arial"); // Adjust the font and size as needed
        const minWidth = Math.max(90, textWidth + 16); // Set a minimum width and add padding

        return {
          headerName: headerText,
          field: column.column_name,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          cellClass: "pmt-ag-cell-font capitalizeNone",
          minWidth,
        };
      });
    console.log("dynamic columns==", dynamicColumns);
    // Combine static and dynamic columns
    return [...staticColumns, ...dynamicColumns];
  }

  // Function to measure text width
  function getTextWidth(text, font) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = font;
    const width = context.measureText(text).width;
    return width;
  }

  const [exportLoading, setExportLoading] = useState(false);
  const exportData = async (e) => {
    e.preventDefault();
    setExportLoading(true);

    getReportsExportExcelData(
      user?.token,
      onInputSearch
        ? {
            file: "xlsx",
            ...onInputSearch,
            report_name: params.tableName,
          }
        : {
            exporttoexcel: "xlsx",
            report_name: params.tableName,
          }
    )
      .then((blob) => {
        setExportLoading(false);

        const blb = new Blob([blob.data], { type: "text/csv" });
        saveAs(
          blb,
          onInputSearch.period === undefined
            ? `${onInputSearch.subsidiary}.csv`
            : onInputSearch.year === undefined
            ? `${onInputSearch.subsidiary}.csv`
            : onInputSearch.subsidiary === undefined
            ? `${onInputSearch.year}.csv``${onInputSearch.period}.csv`
            : `${onInputSearch.year}_${onInputSearch.subsidiary}.csv``${onInputSearch.period}_${onInputSearch.subsidiary}.csv`
        );
      })
      .catch((error) => {
        setExportLoading(false);

        snackbar.showError("File does not exist");
      });
  };
  console.log(subsidiaryOptions, "subsidiaryOptions");

    //  const getDownloadDocumentById = (id, filename, folder) => {
    //        setPercentComplete(0);
       
    //        const options = {
    //          headers: {
    //            authorization: user?.token,
    //          },
    //          responseType: "blob",
    //          onDownloadProgress: function (progressEvent) {
    //            const newPercentComplete = Math.floor(
    //              (progressEvent.loaded / progressEvent.total) * 100
    //            );
               
    //            console.log(
    //              "percentage====",
    //              progressEvent.loaded,
    //              progressEvent.total
    //            );
    //            setPercentComplete(newPercentComplete); // Update the percentComplete state
    //          },
    //        };
    //        setDownloadInProgress(true); // Start the download progress
    //        getTransactionDownloadfile(
    //          // { id: id },
       
    //          options,
             
    //          { filename: filename, folderpath: folder },
    //        )
    //          .then((blob) => {
    //            const link = document.createElement("a");
    //            link.href = URL.createObjectURL(blob.data);
    //            link.setAttribute("download", `${filename.replace(".html",".pdf")}`);
    //            document.body.appendChild(link);
    //            link.click();
    //            setDialogOpen(false);
    //          })
    //          .catch((err) => {
    //            errorHandler(err);
    //            setDownloadInProgress(false);
    //            setDialogOpen(false);
    //          })
    //          .finally(() => {
    //            setDownloadInProgress(false);
    //            setDialogOpen(false);
    //            // Download completed or errored, stop progress
    //          });
    //      };
  return (
     <Box className="viewBox">
            <Box className="viewDetilsBox">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        // pb={2}
      >
        <Typography component="h5" fontWeight={500} className="pageHeading1">
          Report Detail
        </Typography>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        pb={2}
      >
        <Typography component="h5" fontWeight={4500} className="pageHeading1">
        {params.reportName.replace("!", "/")}
        </Typography>
        <Button size="small" variant="contained" className="backBtn" onClick={() =>navigate("/saved-search")}>
                      Go Back
                    </Button>
      </Box>

      {params.tableName === "generalledger" ? (
        <>
          <Box className="filter-box">
            <Grid container spacing={2}>
              <Grid item md={3} sm={6} xs={12}>
                <FormControl sx={{ width: "100%" }} className="dropDownLabel">
                  <InputLabel id="select-year-label">Select Year</InputLabel>
                  <Select
                    labelId="select-year-label"
                    id="select-year"
                    value={yearSearchInputValue}
                    label="Select Year"
                    onChange={onYearInputSearch}
                  >
                    <MenuItem value="2024">Year 2024</MenuItem>
                    <MenuItem value="2023">Year 2023</MenuItem>
                    <MenuItem value="2022">Year 2022</MenuItem>
                    <MenuItem value="2021">Year 2021</MenuItem>
                    <MenuItem value="2020">Year 2020</MenuItem>
                    <MenuItem value="2019">Year 2019</MenuItem>
                    <MenuItem value="2018">Year 2018</MenuItem>
                    <MenuItem value="2017">Year 2017</MenuItem>
                    <MenuItem value="2016">Year 2016</MenuItem>
                    <MenuItem value="2015">Year 2015</MenuItem>
                    <MenuItem value="2014">Year 2014</MenuItem>
                    <MenuItem value="2013">Year 2013</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <FormControl sx={{ width: "100%" }} className="dropDownLabel">
                  <InputLabel id="select-month-label">Select Month</InputLabel>
                  <Select
                    labelId="select-month-label"
                    id="select-month"
                    value={monthSearchInputValue}
                    label="Select Month"
                    onChange={onMonthInputSearch}
                  >
                    <MenuItem value="1">January</MenuItem>
                    <MenuItem value="2">February</MenuItem>
                    <MenuItem value="3">March</MenuItem>
                    <MenuItem value="4">April</MenuItem>
                    <MenuItem value="5">May</MenuItem>
                    <MenuItem value="6">June</MenuItem>
                    <MenuItem value="7">July</MenuItem>
                    <MenuItem value="8">August</MenuItem>
                    <MenuItem value="9">September</MenuItem>
                    <MenuItem value="10">October</MenuItem>
                    <MenuItem value="11">November</MenuItem>
                    <MenuItem value="12">December</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item md={3} sm={6} xs={12}>
                <FormControl sx={{ width: "100%" }} className="dropDownLabel">
                  <InputLabel id="select-subsidiary-label">
                    Select Subsidiary
                  </InputLabel>
                  <Select
                    labelId="select-subsidiary-label"
                    id="select-subsidiary"
                    value={subsidiarySearchInputValue}
                    label="Select Subsidiary"
                    onChange={onSubsidiaryInputSearch}
                  >
                     {
                      subsidiaryOptions?.map((e)=>{
                        return (
                          <MenuItem key={e.consolidated_subsidiary} value={e.consolidated_subsidiary}>
                            {e.consolidated_subsidiary}
                          </MenuItem>
                        );
                      })
                    }
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                md={3}
                sm={6}
                xs={12}
                spacing={2}
                display={"flex"}
                justifyContent="space-between"
              >
                <Grid item md={4} sm={6} xs={6} className="m-b-10">
                  <Button
                    type="button"
                    style={{ color: "black", marginTop: "12px" }}
                    onClick={(e) => handleReset(e)}
                  >
                    Reset
                  </Button>
                </Grid>

                <Grid item md={4} sm={4} xs={6} className="m-b-10">
                  {onInputSearch.period === undefined &&
                  onInputSearch.subsidiary === undefined ? (
                    <Button
                      disabled
                      style={{ color: "black", marginTop: "12px" }}
                      type="button"
                    >
                      Export
                    </Button>
                  ) : (
                    <Button
                      disabled={exportLoading}
                      type="button"
                      style={{ color: "black", marginTop: "12px" }}
                      onClick={(e) => exportData(e)}
                    >
                      {exportLoading ? "Please wait..!" : "Export"}
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : params.tableName === "AucernaBS_Dec2020_Aug2022_50" ||
        params.tableName === "MHP_LMonthlyAnalysis_ECP_L_Sharedcosts" ||
        params.tableName === "AdaptiveBalanceSheet_AdaptiveMH" ||
        params.tableName === "EntityTrialBalancebyMonth_MH" ? (
        <>
          
        </>
      // ) : params.tableName === "reconciliationdetail_reports" 
      //    ? (
      //   <>
      //     <Box className="filter-box">
      //       <Grid container spacing={{ sm: 2, md: 2 }}>
      //         <Grid item md={4} sm={5} xs={12} sx={{ marginBottom: "2px" }}>
      //           {/* <FormControl fullWidth className="dropDownLabel">
                
      //             <TextField
      //               labelId="demo-simple-select-label"
      //               id="demo-simple-select"
      //               type="date"
      //               label="Select Date"
      //               value={dateSearchInputValue}
      //               onChange={onDateInputSearch}
      //               fullWidth
      //               InputLabelProps={{
      //                 shrink: true,
      //               }}
      //             />
      //           </FormControl> */}
      //           <FormControl sx={{ width: "100%" }} className="dropDownLabel">
      //             <InputLabel id="select-year-label">Select Year</InputLabel>
      //             <Select
      //               labelId="select-year-label"
      //               id="select-year"
      //               value={yearSearchInputValue}
      //               label="Select Year"
      //               onChange={onYearInputSearch}
      //             >
      //               <MenuItem value="2024">Year 2024</MenuItem>
      //               <MenuItem value="2023">Year 2023</MenuItem>
      //               <MenuItem value="2022">Year 2022</MenuItem>
      //               <MenuItem value="2021">Year 2021</MenuItem>
      //               <MenuItem value="2020">Year 2020</MenuItem>
      //               <MenuItem value="2019">Year 2019</MenuItem>
      //               <MenuItem value="2018">Year 2018</MenuItem>
      //               <MenuItem value="2017">Year 2017</MenuItem>
      //               <MenuItem value="2016">Year 2016</MenuItem>
      //               <MenuItem value="2015">Year 2015</MenuItem>
      //               <MenuItem value="2014">Year 2014</MenuItem>
      //               <MenuItem value="2013">Year 2013</MenuItem>
      //             </Select>
      //           </FormControl>
      //         </Grid>
      //         <Grid item md={4} sm={5} xs={12}>
      //           <FormControl fullWidth className="dropDownLabel">
      //             <InputLabel id="demo-simple-select-label">
      //               Select Subsidiary
      //             </InputLabel>
      //             <Select
      //               labelId="demo-simple-select-label"
      //               id="demo-simple-select"
      //               value={subsidiarySearchInputValue}
      //               label="Select Subsidiary"
      //               onChange={onSubsidiaryInputSearch}
      //             >
      //             <MenuItem value="Consolidated Subsidiary">
      //             Consolidated Subsidiary
      //               </MenuItem>
      //               <MenuItem value="Parent Sub Placeholder">
      //                 Parent Sub Placeholder
      //               </MenuItem>
                  
      //             </Select>
      //           </FormControl>
      //         </Grid>
      //         <Grid item md={2} sm={2} xs={6}>
      //           <Button
      //             type="button"
      //             style={{ color: "black", marginTop: "12px" }}
      //             onClick={(e) => handleReset(e)}
      //           >
      //             Reset
      //           </Button>
      //         </Grid>
      //         <Grid
      //           item
      //           md={2}
      //           sm={12}
      //           xs={6}
      //           style={{ justifyContent: "flex-end", display: "flex" }}
      //         >
      //           {onInputSearch.period === undefined &&
      //           onInputSearch.subsidiary === undefined ? (
      //             <>
      //               <Button disabled type="button">
      //                 Export
      //               </Button>
      //             </>
      //           ) : (
      //             <>
      //               <Button
      //                 disabled={exportLoading}
      //                 type="button"
      //                 onClick={(e) => exportData(e)}
      //               >
      //                 {exportLoading ? "Please wait..!" : "Export"}
      //               </Button>
      //             </>
      //           )}
      //         </Grid>
      //       </Grid>
      //     </Box>
      //   </>
      ) : params.tableName === "balancesheetbyperiod" ||
        // params.tableName === " lifepoint_pc_3362_3365_ap_transactions_reports" ||
        params.tableName === "profitandlossbyperiod" ? (
        <>
          <Box className="filter-box">
            <Grid container spacing={{ sm: 2, md: 2 }}>
              <Grid item md={4} sm={5} xs={12} sx={{ marginBottom: "2px" }}>
                <FormControl fullWidth className="dropDownLabel">
                  <InputLabel id="demo-simple-select-label">
                    Select Period
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={periodSearchInputValue}
                    label="Select Period"
                    onChange={onPeriodInputSearch}
                  >
                    <MenuItem value="FY 2015" className="dropDownHeading1">
                      FY 2015
                    </MenuItem>
                    <MenuItem value="Q1 2015" className="dropDownHeading2">
                      Q1 2015
                    </MenuItem>
                    <MenuItem value="Jan 2015">Jan 2015</MenuItem>
                    <MenuItem value="Feb 2015">Feb 2015</MenuItem>
                    <MenuItem value="Mar 2015">Mar 2015</MenuItem>
                    <MenuItem value="Q2 2015" className="dropDownHeading2">
                      Q2 2015
                    </MenuItem>
                    <MenuItem value="Apr 2015">Apr 2015</MenuItem>
                    <MenuItem value="May 2015">May 2015</MenuItem>
                    <MenuItem value="Jun 2015">Jun 2015</MenuItem>
                    <MenuItem value="Q3 2015" className="dropDownHeading2">
                      Q3 2015
                    </MenuItem>
                    <MenuItem value="Jul 2015">Jul 2015</MenuItem>
                    <MenuItem value="Aug 2015">Aug 2015</MenuItem>
                    <MenuItem value="Sep 2015">Sep 2015</MenuItem>
                    <MenuItem value="Q4 2015" className="dropDownHeading2">
                      Q4 2015
                    </MenuItem>
                    <MenuItem value="Oct 2015">Oct 2015</MenuItem>
                    <MenuItem value="Nov 2015">Nov 2015</MenuItem>
                    <MenuItem value="Dec 2015">Dec 2015</MenuItem>
                    <MenuItem value="FY 2016" className="dropDownHeading1">
                      FY 2016
                    </MenuItem>
                    <MenuItem value="Q1 2016" className="dropDownHeading2">
                      Q1 2016
                    </MenuItem>
                    <MenuItem value="Jan 2016">Jan 2016</MenuItem>
                    <MenuItem value="Feb 2016">Feb 2016</MenuItem>
                    <MenuItem value="Mar 2016">Mar 2016</MenuItem>
                    <MenuItem value="Q2 2016" className="dropDownHeading2">
                      Q2 2016
                    </MenuItem>
                    <MenuItem value="Apr 2016">Apr 2016</MenuItem>
                    <MenuItem value="May 2016">May 2016</MenuItem>
                    <MenuItem value="Jun 2016">Jun 2016</MenuItem>
                    <MenuItem value="Q3 2016" className="dropDownHeading2">
                      Q3 2016
                    </MenuItem>
                    <MenuItem value="Jul 2016">Jul 2016</MenuItem>
                    <MenuItem value="Aug 2016">Aug 2016</MenuItem>
                    <MenuItem value="Sep 2016">Sep 2016</MenuItem>
                    <MenuItem value="Q4 2016" className="dropDownHeading2">
                      Q4 2016
                    </MenuItem>
                    <MenuItem value="Oct 2016">Oct 2016</MenuItem>
                    <MenuItem value="Nov 2016">Nov 2016</MenuItem>
                    <MenuItem value="Dec 2016">Dec 2016</MenuItem>
                    <MenuItem value="FY 2017" className="dropDownHeading1">
                      FY 2017
                    </MenuItem>
                    <MenuItem value="Q1 2017" className="dropDownHeading2">
                      Q1 2017
                    </MenuItem>
                    <MenuItem value="Jan 2017">Jan 2017</MenuItem>
                    <MenuItem value="Feb 2017">Feb 2017</MenuItem>
                    <MenuItem value="Mar 2017">Mar 2017</MenuItem>
                    <MenuItem value="Q2 2017" className="dropDownHeading2">
                      Q2 2017
                    </MenuItem>
                    <MenuItem value="Apr 2017">Apr 2017</MenuItem>
                    <MenuItem value="May 2017">May 2017</MenuItem>
                    <MenuItem value="Jun 2017">Jun 2017</MenuItem>
                    <MenuItem value="Q3 2017" className="dropDownHeading2">
                      Q3 2017
                    </MenuItem>
                    <MenuItem value="Jul 2017">Jul 2017</MenuItem>
                    <MenuItem value="Aug 2017">Aug 2017</MenuItem>
                    <MenuItem value="Sep 2017">Sep 2017</MenuItem>
                    <MenuItem value="Q4 2017" className="dropDownHeading2">
                      Q4 2017
                    </MenuItem>
                    <MenuItem value="Oct 2017">Oct 2017</MenuItem>
                    <MenuItem value="Nov 2017">Nov 2017</MenuItem>
                    <MenuItem value="Dec 2017">Dec 2017</MenuItem>
                    <MenuItem value="FY 2018" className="dropDownHeading1">
                      FY 2018
                    </MenuItem>
                    <MenuItem value="Q1 2018" className="dropDownHeading2">
                      Q1 2018
                    </MenuItem>
                    <MenuItem value="Jan 2018">Jan 2018</MenuItem>
                    <MenuItem value="Feb 2018">Feb 2018</MenuItem>
                    <MenuItem value="Mar 2018">Mar 2018</MenuItem>
                    <MenuItem value="Q2 2018" className="dropDownHeading2">
                      Q2 2018
                    </MenuItem>
                    <MenuItem value="Apr 2018">Apr 2018</MenuItem>
                    <MenuItem value="May 2018">May 2018</MenuItem>
                    <MenuItem value="Jun 2018">Jun 2018</MenuItem>
                    <MenuItem value="Q3 2018" className="dropDownHeading2">
                      Q3 2018
                    </MenuItem>
                    <MenuItem value="Jul 2018">Jul 2018</MenuItem>
                    <MenuItem value="Aug 2018">Aug 2018</MenuItem>
                    <MenuItem value="Sep 2018">Sep 2018</MenuItem>
                    <MenuItem value="Q4 2018" className="dropDownHeading2">
                      Q4 2018
                    </MenuItem>
                    <MenuItem value="Oct 2018">Oct 2018</MenuItem>
                    <MenuItem value="Nov 2018">Nov 2018</MenuItem>
                    <MenuItem value="Dec 2018">Dec 2018</MenuItem>
                    <MenuItem value="FY 2019" className="dropDownHeading1">
                      FY 2019
                    </MenuItem>
                    <MenuItem value="Q1 2019" className="dropDownHeading2">
                      Q1 2019
                    </MenuItem>
                    <MenuItem value="Jan 2019">Jan 2019</MenuItem>
                    <MenuItem value="Feb 2019">Feb 2019</MenuItem>
                    <MenuItem value="Mar 2019">Mar 2019</MenuItem>
                    <MenuItem value="Q2 2019" className="dropDownHeading2">
                      Q2 2019
                    </MenuItem>
                    <MenuItem value="Apr 2019">Apr 2019</MenuItem>
                    <MenuItem value="May 1st - 12th 2019 (Pre Thoma)">
                      May 1st - 12th 2019 (Pre Thoma)
                    </MenuItem>
                    <MenuItem value="May 13th - 31st 2019 (Post Thoma)">
                      May 13th - 31st 2019 (Post Thoma)
                    </MenuItem>
                    <MenuItem value="Jun 2019">Jun 2019</MenuItem>
                    <MenuItem value="Q3 2019" className="dropDownHeading2">
                      Q3 2019
                    </MenuItem>
                    <MenuItem value="Jul 2019">Jul 2019</MenuItem>
                    <MenuItem value="Aug 2019">Aug 2019</MenuItem>
                    <MenuItem value="Sep 2019">Sep 2019</MenuItem>
                    <MenuItem value="Q4 2019" className="dropDownHeading2">
                      Q4 2019
                    </MenuItem>
                    <MenuItem value="Oct 2019">Oct 2019</MenuItem>
                    <MenuItem value="Nov 2019">Nov 2019</MenuItem>
                    <MenuItem value="Dec 2019">Dec 2019</MenuItem>
                    <MenuItem value="FY 2020" className="dropDownHeading1">
                      FY 2020
                    </MenuItem>
                    <MenuItem value="Q1 2020" className="dropDownHeading2">
                      Q1 2020
                    </MenuItem>
                    <MenuItem value="Jan 2020">Jan 2020</MenuItem>
                    <MenuItem value="Feb 2020">Feb 2020</MenuItem>
                    <MenuItem value="Mar 2020">Mar 2020</MenuItem>
                    <MenuItem value="Q2 2020" className="dropDownHeading2">
                      Q2 2020
                    </MenuItem>
                    <MenuItem value="Apr 2020">Apr 2020</MenuItem>
                    <MenuItem value="May 2020">May 2020</MenuItem>
                    <MenuItem value="Jun 2020">Jun 2020</MenuItem>
                    <MenuItem value="Q3 2020" className="dropDownHeading2">
                      Q3 2020
                    </MenuItem>
                    <MenuItem value="Jul 2020">Jul 2020</MenuItem>
                    <MenuItem value="Aug 2020">Aug 2020</MenuItem>
                    <MenuItem value="Sep 2020">Sep 2020</MenuItem>
                    <MenuItem value="Q4 2020" className="dropDownHeading2">
                      Q4 2020
                    </MenuItem>
                    <MenuItem value="Oct 2020">Oct 2020</MenuItem>
                    <MenuItem value="Nov 2020">Nov 2020</MenuItem>
                    <MenuItem value="Dec 2020">Dec 2020</MenuItem>
                    <MenuItem value="FY 2021" className="dropDownHeading1">
                      FY 2021
                    </MenuItem>
                    <MenuItem value="Q1 2021" className="dropDownHeading2">
                      Q1 2021
                    </MenuItem>
                    <MenuItem value="Jan 2021">Jan 2021</MenuItem>
                    <MenuItem value="Feb 2021">Feb 2021</MenuItem>
                    <MenuItem value="Mar 2021">Mar 2021</MenuItem>
                    <MenuItem value="Q2 2021" className="dropDownHeading2">
                      Q2 2021
                    </MenuItem>
                    <MenuItem value="Apr 2021">Apr 2021</MenuItem>
                    <MenuItem value="May 2021">May 2021</MenuItem>
                    <MenuItem value="Jun 2021">Jun 2021</MenuItem>
                    <MenuItem value="Q3 2021" className="dropDownHeading2">
                      Q3 2021
                    </MenuItem>
                    <MenuItem value="Jul 2021">Jul 2021</MenuItem>
                    <MenuItem value="Aug 2021">Aug 2021</MenuItem>
                    <MenuItem value="Sep 2021">Sep 2021</MenuItem>
                    <MenuItem value="Q4 2021" className="dropDownHeading2">
                      Q4 2021
                    </MenuItem>
                    <MenuItem value="Oct 2021">Oct 2021</MenuItem>
                    <MenuItem value="Nov 2021">Nov 2021</MenuItem>
                    <MenuItem value="Dec 2021">Dec 2021</MenuItem>
                    <MenuItem value="FY 2022" className="dropDownHeading1">
                      FY 2022
                    </MenuItem>
                    <MenuItem value="Q1 2022" className="dropDownHeading2">
                      Q1 2022
                    </MenuItem>
                    <MenuItem value="Jan 2022">Jan 2022</MenuItem>
                    <MenuItem value="Feb 2022">Feb 2022</MenuItem>
                    <MenuItem value="Mar 2022">Mar 2022</MenuItem>
                    <MenuItem value="Q2 2022" className="dropDownHeading2">
                      Q2 2022
                    </MenuItem>
                    <MenuItem value="Apr 2022">Apr 2022</MenuItem>
                    <MenuItem value="May 2022">May 2022</MenuItem>
                    <MenuItem value="Jun 2022">Jun 2022</MenuItem>
                    <MenuItem value="Q3 2022" className="dropDownHeading2">
                      Q3 2022
                    </MenuItem>
                    <MenuItem value="Jul 2022">Jul 2022</MenuItem>
                    <MenuItem value="Aug 2022">Aug 2022</MenuItem>
                    <MenuItem value="Sep 2022">Sep 2022</MenuItem>
                    <MenuItem value="Q4 2022" className="dropDownHeading2">
                      Q4 2022
                    </MenuItem>
                    <MenuItem value="Oct 2022">Oct 2022</MenuItem>
                    <MenuItem value="Nov 2022">Nov 2022</MenuItem>
                    <MenuItem value="Dec 2022">Dec 2022</MenuItem>
                    <MenuItem value="FY 2023" className="dropDownHeading1">
                      FY 2023
                    </MenuItem>
                    <MenuItem value="Q1 2023" className="dropDownHeading2">
                      Q1 2023
                    </MenuItem>
                    <MenuItem value="Jan 2023">Jan 2023</MenuItem>
                    <MenuItem value="Feb 2023">Feb 2023</MenuItem>
                    <MenuItem value="Mar 2023">Mar 2023</MenuItem>
                    <MenuItem value="Q2 2023" className="dropDownHeading2">
                      Q2 2023
                    </MenuItem>
                    <MenuItem value="Apr 2023">Apr 2023</MenuItem>
                    <MenuItem value="May 2023">May 2023</MenuItem>
                    <MenuItem value="Jun 2023">Jun 2023</MenuItem>
                    <MenuItem value="Q3 2023" className="dropDownHeading2">
                      Q3 2023
                    </MenuItem>
                    <MenuItem value="Jul 2023">Jul 2023</MenuItem>
                    <MenuItem value="Aug 2023">Aug 2023</MenuItem>
                    <MenuItem value="Sep 2023">Sep 2023</MenuItem>
                    <MenuItem value="Q4 2023" className="dropDownHeading2">
                      Q4 2023
                    </MenuItem>
                    <MenuItem value="Oct 2023">Oct 2023</MenuItem>
                    <MenuItem value="Nov 2023">Nov 2023</MenuItem>
                    <MenuItem value="Dec 2023">Dec 2023</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={4} sm={5} xs={12}>
                <FormControl fullWidth className="dropDownLabel">
                  <InputLabel id="demo-simple-select-label">
                    Select Subsidiary
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={subsidiarySearchInputValue}
                    label="Select Subsidiary"
                    onChange={onSubsidiaryInputSearch}
                  >
                     {
                      subsidiaryOptions?.map((e)=>{
                        return (
                          <MenuItem key={e.consolidated_subsidiary} value={e.consolidated_subsidiary}>
                            {e.consolidated_subsidiary}
                          </MenuItem>
                        );
                      })
                    }
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={2} sm={2} xs={6}>
                <Button
                  type="button"
                  style={{ color: "black", marginTop: "12px" }}
                  onClick={(e) => handleReset(e)}
                >
                  Reset
                </Button>
              </Grid>
              <Grid
                item
                md={2}
                sm={12}
                xs={6}
                style={{ justifyContent: "flex-end", display: "flex" }}
              >
                {onInputSearch.period === undefined &&
                onInputSearch.subsidiary === undefined ? (
                  <>
                    <Button disabled type="button">
                      Export
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      disabled={exportLoading}
                      type="button"
                      onClick={(e) => exportData(e)}
                    >
                      {exportLoading ? "Please wait..!" : "Export"}
                    </Button>
                  </>
                )}
              </Grid>
            </Grid>
          </Box>
        </>
      ) : (
        <>
          {/* <Box className="filter-box">
            <Grid container spacing={{ sm: 2, md: 2 }}>
              <Grid item md={4} sm={5} xs={12} sx={{ marginBottom: "2px" }}>
                
                <FormControl sx={{ width: "100%" }} className="dropDownLabel">
                  <InputLabel id="select-year-label">Select Year</InputLabel>
                  <Select
                    labelId="select-year-label"
                    id="select-year"
                    value={yearSearchInputValue}
                    label="Select Year"
                    onChange={onYearInputSearch}
                  >
                    <MenuItem value="2024">Year 2024</MenuItem>
                    <MenuItem value="2023">Year 2023</MenuItem>
                    <MenuItem value="2022">Year 2022</MenuItem>
                    <MenuItem value="2021">Year 2021</MenuItem>
                    <MenuItem value="2020">Year 2020</MenuItem>
                    <MenuItem value="2019">Year 2019</MenuItem>
                    <MenuItem value="2018">Year 2018</MenuItem>
                    <MenuItem value="2017">Year 2017</MenuItem>
                    <MenuItem value="2016">Year 2016</MenuItem>
                    <MenuItem value="2015">Year 2015</MenuItem>
                    <MenuItem value="2014">Year 2014</MenuItem>
                    <MenuItem value="2013">Year 2013</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={4} sm={5} xs={12}>
                <FormControl fullWidth className="dropDownLabel">
                  <InputLabel id="demo-simple-select-label">
                    Select Subsidiary
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={subsidiarySearchInputValue}
                    label="Select Subsidiary"
                    onChange={onSubsidiaryInputSearch}
                  >
                    {
                      subsidiaryOptions?.map((e)=>{
                        return (
                          <MenuItem key={e.consolidated_subsidiary} value={e.consolidated_subsidiary}>
                            {e.consolidated_subsidiary}
                          </MenuItem>
                        );
                      })
                    }
                  
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={2} sm={2} xs={6}>
                <Button
                  type="button"
                  style={{ color: "black", marginTop: "12px" }}
                  onClick={(e) => handleReset(e)}
                >
                  Reset
                </Button>
              </Grid>
              <Grid
                item
                md={2}
                sm={12}
                xs={6}
                style={{ justifyContent: "flex-end", display: "flex" }}
              >
                {onInputSearch.period === undefined &&
                onInputSearch.subsidiary === undefined ? (
                  <>
                    <Button disabled type="button">
                      Export
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      disabled={exportLoading}
                      type="button"
                      onClick={(e) => exportData(e)}
                    >
                      {exportLoading ? "Please wait..!" : "Export"}
                    </Button>
                  </>
                )}
              </Grid>
            </Grid>
          </Box> */}
        </>
      )}
      <Paper elevation={3}>
        <AgGridPaginatedTable
          getTableRows={getReportsListByReportNameData}
          columns={reportViewTableColumns}
          perPage={10}
          refreshCounter={tableRefreshCount}
          onInputSearch={onInputSearch}
          // onCellClicked={(params) => {
          //   console.log("Prarams-===", params);
          //   if (params.colDef.field === "File Name") {
          //     setDialogOpen(true);
          //     getDownloadDocumentById(
          //       params.data.transaction_id,
          //       params.data.value,
          //       params.data.folder
          //     );
          //   }
          //   return;
          // }}
        />
      </Paper>
         {/* <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
               <DialogTitle>Download Progress</DialogTitle>
               <DialogContent>
                 {downloadInProgress ? (
                   <>
                     <CircularProgress
                      variant="indeterminate"  
                       value={percentComplete}
                       size={50}
                       thickness={10}
                       style={{ marginLeft: "65px" }}
                     />
                     <Box
                       sx={{
                         marginTop: 2, 
                         textAlign: "center", 
                         fontSize: "16px", 
                         color: "#333",
                         "&:hover": {
                           color: "#1976d2",
                           cursor: "pointer",
                         }
                       }}
                     >
                       <span>Please wait...</span>
                     </Box>
                   </>
                 ) : (
                   <></>
                 )}
               </DialogContent>
              
             </Dialog> */}
    </Box></Box>
  );
}
